// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"9a8a6595","213":"5ca979a4","265":"6067056f","395":"7c636658","473":"e454afe7","539":"356a4a11","564":"93efc6f4","624":"96fe4672","732":"fc0ada83","865":"5fcaa4cd","882":"4a31f455"}[chunkId] + ".chunk.js";
};